import Typography from "@mui/material/Typography";
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Paper,
    Stack, TextField, Tooltip} from "@mui/material";
import {useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import * as React from "react";
import {DeleteRounded, ExpandMore, FileUploadRounded, DownloadRounded, CreateRounded} from "@mui/icons-material";
import {useFieldArray, useForm } from "react-hook-form";
import {FormTextField, FormAutocomplete, FormCheckbox} from "../../../common/form-fields-wrappers";
import {useEffect, useState} from "react";
import {sendCheckedDocument, uploadDocument} from "../../applicationDetail.actions";
import {applicationInfoState, documentsApplicationState} from "../../../searchms/state";
import { useRecoilState } from "recoil";
import {useNavigate} from "react-router-dom";
import ContentBody from "../../../common/content-body/ContentBody";
import { AxiosError } from "axios";
import {APPLICATION_DOCUMENTS_FORM_VALIDATION_SCHEMA, APPLICATION_SEND_EMAIL_FORM_VALIDATION_SCHEMA, APPLICATION_STATES} from "../../config";
import {yupResolver} from "@hookform/resolvers/yup";
import DocumentalHistory from "../../../documental-history/DocumentalHistory";
import dayjs from "dayjs";

import {useHasScope} from "../../../../../config/globalConfig";
import { NetworkScope } from "../../../types";

const Documentation = () => {
    const hasScope = useHasScope;
    /*TODO: Implementare chiamata BE per gestire l'invio dei documenti alle autorità ( con email )*/
    const [applicationData, setApplicationData] = useRecoilState(applicationInfoState);
    const [documentsApplication, setDocumentsApplication] = useRecoilState(documentsApplicationState);
    type FormValues = {
        idApplication: string;
        documents: {
            checked: boolean;
            title: string;
            note: string;
            file: string | ArrayBuffer;
            fileName: string;
        }[];
    };
    const documentsList = [
        'Certificate of Incorporation',
        'Legal rapresentative document',
        'License to rent',
        'Last balance sheet',
        'Partners Committee approval',
        'Other'
        ];
    const [isDisabled, setIsDisabled] = useState(true);
    const [isDisabledSend, setIsDisabledSend] = useState(true);
    const [isDisabledEmail, setIsDisabledEmail] = useState(true);
    const theme = useTheme();
    const [update, setUpdate] = useState(true);
    const {t} = useTranslation(['network', 'translation']);
    const [documentsChecked, setDocumentsChecked] = useState(Array<any>);
    const [errorMessage, setErrorMessage] = useState("");
    const [dateOfSent, setDateOfSent] = useState("");

    const documentsForm = useForm<FormValues>({
        defaultValues: {
            idApplication: applicationData.id,
            documents: documentsApplication.documents ?? [],
        },
        resolver: yupResolver(APPLICATION_DOCUMENTS_FORM_VALIDATION_SCHEMA)
    });

    const sendEmailForm = useForm({
        defaultValues: {
            email: applicationData.applicant?.email ?? "",
        },
        resolver: yupResolver(APPLICATION_SEND_EMAIL_FORM_VALIDATION_SCHEMA)

    });

    const documentsArray = useFieldArray({name: 'documents', control: documentsForm.control});

    const handleFileOnChange = (e: React.BaseSyntheticEvent, field: any, index: number) => {
        e.stopPropagation();
        if (!!e.target.files[0]?.size) {
            let reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = function () {
                documentsForm.setValue(field, reader.result);
                documentsForm.trigger(field);
                documentsForm.setValue(`documents.${index}.fileName`, e.target.files[0].name);
                documentsForm.trigger(field);
                setUpdate(!update);
            };
        }

    }
    const onSubmit = (data: FormValues) => {
        const reqParameters = {
            idApplication: applicationData.id,
            documents: data.documents
        }
        uploadDocument(reqParameters)
            .then( (res:any) => {
                setDocumentsApplication(res.documents);
            })
            .catch((err: AxiosError) => {
            });
        setIsDisabled(true);
    }

    const sendDocument = (data: any) => {
        documentsForm.handleSubmit(onSubmit);
        const reqParameters = {
            applicationId: applicationData.id,
            documents: documentsChecked,
            email: data.email
        }
        sendCheckedDocument(reqParameters)
            .then( (res:any) => {
                setDateOfSent(dayjs(res.communicatedToAuthoritiesDate).format("YYYY-MM-DD")) 
            })
            .catch((err: AxiosError) => {
            });
        setOpen(false);
        setIsDisabledEmail(true);
        setDocumentsChecked([]);
    }

    const handleControlDocuments = () => {
        if(documentsChecked.find(o => o.title === 'Certificate of Incorporation') 
        && documentsChecked.find(o => o.title === 'Legal rapresentative document') 
        && documentsChecked.find(o => o.title === 'License to rent')
        && documentsChecked.find(o => o.title === 'Last balance sheet')){
            setIsDisabledSend(false);
            setErrorMessage("")
            
        }
        else {
            setIsDisabledSend(true);
            setErrorMessage("applicationDetail.error.missingRequiredDoc")
        
        }
    }

    const [open, setOpen] = useState(false);
    const [openHistory, setOpenHistory] = useState(false);

    const handleOpen = () => {
        setDocumentsChecked(documentsChecked.filter(item => item.checked === true));
        handleControlDocuments();
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setIsDisabledEmail(true);
        setDocumentsChecked([]);
    }
    const handleOpenHistory = () => setOpenHistory(true);
    const handleCloseHistory = () => setOpenHistory(false);
    const handleOnDelete = ( index?: number) => {
        documentsArray.remove(index);
    }
    const handleAddDocument = () => {
        documentsArray.append({
            checked: false,
            title: '',
            note: '' ,
            file:'',
            fileName: ''});
    }

    const [isSendDisabled, setIsSendDisabled] = useState(applicationData.currentStatus !== APPLICATION_STATES.ACCEPTED_BY_COMMITTEE || applicationData.applicant?.newPartner === false);

    const downloadFunc = (data: string, fileName?: string) => {
        const linkSource = data;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName ? fileName : 'file';
        downloadLink.click();
    };
    const downloadDocument = (base64: string | ArrayBuffer, fileName?:string) => {
            downloadFunc(base64.toString(), fileName);
    };

    const updateComponent = () => {
        setUpdate(!update);
    }

    let navigate = useNavigate();
    const routeChange = (idAssociatedDms: any) => {
        let path = `/mobility-store/dms-detail/${idAssociatedDms}`;
        navigate(path, {state:
                {msId:idAssociatedDms}
        });
    }

    const handleDisableForm = (value:boolean) => {
        setIsDisabled(value);
    }

    const handleDisableEmail = (value:boolean) => {
        setIsDisabledEmail(value);
    }

    const dropChanges = () => {
        documentsArray.replace(documentsApplication);
        setIsDisabled(true);
        setUpdate(!update);
    }

    const handleSelectDocument = (e: React.BaseSyntheticEvent, field: any, index: number) => {
        if(documentsForm.getValues(`documents.${index}.checked`) !== true){
            documentsForm.setValue(`documents.${index}.checked`, true)
            let doc = documentsForm.getValues(`documents.${index}`)
            documentsChecked.push(doc)
        }
        else if(documentsForm.getValues(`documents.${index}.checked`) === true){
            documentsForm.setValue(`documents.${index}.checked`, false)
            setDocumentsChecked(documentsChecked.filter(item => item.checked === true))
        }
    }

    useEffect(() => {
    },[update])

    useEffect( () => {
        documentsForm.setValue("documents", documentsApplication)
    }, [documentsApplication])

    return(
        <>
            <ContentBody>
                <Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
                    <Accordion defaultExpanded={true}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography variant={"h6"}>
                                {t("applicationDetail.form.label.associatedDms")}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid item container xs={12} spacing={2}>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        id="dmsNaming"
                                        name="dmsNaming"
                                        label={t("applicationDetail.form.label.dmsNaming")}
                                        defaultValue={applicationData.dmsNaming}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        id="dmsIdentifyingCode"
                                        name="dmsIdentifyingCode"
                                        label={t("applicationDetail.form.label.dmsIdentifyingCode")}
                                        defaultValue={applicationData.dmsIdentifyingCode}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        id="dmsCity"
                                        name="dmsCity"
                                        label={t("applicationDetail.form.label.dmsCity")}
                                        defaultValue={applicationData.dmsCity}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    {applicationData.msId != null ?
                                        <Grid item xs={3}>
                                            <Button onClick={() => routeChange(applicationData.msId)}>
                                                {t("applicationDetail.form.label.dmsDetail")}
                                            </Button>
                                        </Grid> : null}

                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion defaultExpanded={true}>
                        <AccordionSummary expandIcon={<ExpandMore/>}>
                            <Typography variant={"h6"}>
                                {t("applicationDetail.form.label.documents")}
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <form onSubmit={documentsForm.handleSubmit(onSubmit)}>
                              { hasScope( NetworkScope.MsMng) &&
                                    <Grid item xs={12}>
                                        <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                                            { isDisabled &&
                                                <Tooltip title={t("applicationDetail.tooltip.edit")}>
                                                    <IconButton sx={{mx: theme.spacing(0.5)}} color={"accent"}
                                                                onClick={() => {handleDisableForm(false)}}>
                                                        <CreateRounded />
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                        </Stack>
                                    </Grid>
                                }
                                {documentsArray.fields.length === 0 &&
                                    <Grid item container xs={12} md={12} align-items="center" justifyContent="flex">
                                        <p>{t("applicationDetail.form.label.noDocuments")}</p>
                                    </Grid>
                                }
                                {documentsArray.fields.map((field, index) => {
                                    return (
                                        <Grid key={field.id} item container md={12} xs={12} >

                                            {isDisabled === false ?
                                                <>
                                                    <Grid item xs={1} md={1} sx={{display: "flex", justifyContent: "center"}}>
                                                        <Grid item md={2} xs={2} sx={{alignSelf: "end"}}>
                                                            <FormCheckbox 
                                                                name={`documents.${index}.checked`} 
                                                                label={""}   
                                                                control={documentsForm.control}
                                                                onClick={(e: React.SyntheticEvent) => handleSelectDocument(e, `documents.${index}.checked`, index)}
                                                            /> 
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container item md={9} xs={9} columnSpacing={2}>                                                      
                                                        <Grid item md={4} xs={4}>
                                                            <FormAutocomplete
                                                                disabled={isDisabled}
                                                                name={`documents.${index}.title`}
                                                                control={documentsForm.control}
                                                                options={documentsList}
                                                                label={t("applicationDetail.form.label.title")}
                                                            />
                                                        </Grid>

                                                        <Grid item md={8} xs={8}>
                                                            <FormTextField
                                                                disabled={isDisabled}
                                                                control={documentsForm.control}
                                                                name={`documents.${index}.note`}
                                                                label={t("applicationDetail.form.label.notes")}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                    <Grid item xs={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                                        {documentsForm.getValues(`documents.${index}.file`) !== "" &&
                                                            <IconButton color="secondary" component="label"
                                                                        sx={{alignSelf: "end"}}>
                                                                <input hidden
                                                                       type="file"
                                                                       onChange={(e: React.SyntheticEvent) => handleFileOnChange(e, `documents.${index}.file`, index)}
                                                                />
                                                                <FileUploadRounded/>
                                                            </IconButton>}

                                                        { documentsForm.getValues(`documents.${index}.file`) === "" && <IconButton color="error" component="label" sx={{alignSelf: "end"}}>
                                                            <input hidden accept="image/*"
                                                                   type="file"
                                                                   onChange={(e: React.SyntheticEvent) => handleFileOnChange(e, `documents.${index}.file`, index)}
                                                            />
                                                            <FileUploadRounded/>
                                                        </IconButton>}


                                                        { documentsForm.getValues(`documents.${index}.file`) !== "" ?
                                                            <Box sx={{
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                alignSelf: "end"
                                                            }}>
                                                                <IconButton color="secondary"
                                                                            onClick={(e: React.SyntheticEvent) => downloadDocument(documentsForm.getValues(`documents.${index}.file`), documentsForm.getValues(`documents.${index}.title`))}>
                                                                    <DownloadRounded/>
                                                                </IconButton>
                                                            </Box>
                                                            : null}

                                                        <Box sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            alignSelf: "end"
                                                        }}>
                                                            <IconButton color="secondary" onClick={() => handleOnDelete(index)}>
                                                                <DeleteRounded/>
                                                            </IconButton>
                                                        </Box>
                                                    </Grid>
                                                </>

                                                : <Grid container item md={12} xs={12} columnSpacing={2}>
                                                    <Grid item md={4} xs={4}>
                                                        <FormAutocomplete
                                                            disabled={isDisabled}
                                                            name={`documents.${index}.title`}
                                                            control={documentsForm.control}
                                                            options={documentsList}
                                                            label={t("applicationDetail.form.label.title")}
                                                        />
                                                    </Grid>

                                                    <Grid item md={8} xs={8}>
                                                        <FormTextField
                                                            disabled={isDisabled}
                                                            control={documentsForm.control}
                                                            name={`documents.${index}.note`}
                                                            label={t("applicationDetail.form.label.note")}
                                                        />
                                                    </Grid>

                                                </Grid>}
                                        </Grid>
                                    );
                                })}
                                {!isDisabled &&
                                    <Grid container sx={{display: 'flex', justifyContent: "flex-end", alignItems: "flex-end", marginTop: 2}}  >
                                        <Grid xs={12} md={8} item sx={{display: 'flex', justifyContent: {xs: 'center', md: 'flex-start'}, gap: {xs: 1, md: 2}, flexDirection: {xs: 'column', md: 'row'}, padding: {xs: 1, md: 0}}}>
                                            <Button onClick={handleOpenHistory} >
                                                {t("applicationDetail.form.label.archive")}
                                            </Button>

                                            <Button color={"accent"} onClick={handleAddDocument}>
                                                {t("applicationDetail.button.addDocument")}
                                            </Button>
                                            {documentsArray.fields.length > 0 &&
                                                <Button disabled={isSendDisabled} onClick={handleOpen}>
                                                    {t("applicationDetail.button.sendToAuthorities")}
                                                </Button>
                                            }
                                        </Grid>
                                        <Grid xs={12} md={4} item sx={{display: 'flex', justifyContent: {xs: 'center', md: 'flex-end'}, gap: {xs: 1, md: 2}, flexDirection: {xs: 'column', md: 'row'}, padding: {xs: 1, md: 0}}}>
                                            <Button color={"accent"} onClick={dropChanges}>
                                                {t('applicationDetail.button.cancel')}
                                            </Button>
                                            <Button type={"submit"} onClick={documentsForm.handleSubmit(onSubmit)}>
                                                {t('applicationDetail.button.confirm')}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                }
                                <Grid item container xs={12} md={12}  justifyContent="flex-end" alignItems="flex-end">
                                    {
                                        dateOfSent !== "" &&
                                        <Box sx={{my: theme.spacing(2), mx: theme.spacing(2)}}>
                                            <Typography>{t("applicationDetail.form.label.comunicationAuthoritiesDate")} {dateOfSent}</Typography>
                                        </Box>
                                    }
                                </Grid>
                            </form>
                        </AccordionDetails>
                    </Accordion>

                </Paper>
            </ContentBody>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("applicationDetail.modal.titleSendDoc")}
                </DialogTitle>
                
                <form onSubmit={sendEmailForm.handleSubmit(sendDocument)}>
                    <DialogContent>
                        <Typography>{t("applicationDetail.modal.titleSendDoc")}</Typography>
                        <Grid item container xs={12} md={12} align-items="center" justifyContent="flex">
                            <Grid item xs={10}>
                                <FormTextField
                                    disabled={isDisabledEmail}
                                    name={'email'}
                                    control={sendEmailForm.control}
                                    label={t("applicationDetail.form.label.email")}
                                />
                            </Grid>
                             { hasScope( NetworkScope.MsMng) &&
                                <Grid item xs={2} alignSelf="flex-end">
                                    <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                                        { isDisabledEmail &&
                                            <Tooltip title={t("applicationDetail.tooltip.edit")}>
                                                <IconButton sx={{mx: theme.spacing(0.5)}} color={"accent"}
                                                            onClick={() => {handleDisableEmail(false)}}>
                                                    <CreateRounded />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </Stack>
                                </Grid>
                             }
                        </Grid>
                        <Typography color={'error'}>{errorMessage}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={sendEmailForm.handleSubmit(sendDocument)} disabled={isDisabledSend}>
                            {t("applicationDetail.button.confirm")}
                        </Button>
                        <Button onClick={handleClose}>{t("applicationDetail.button.cancel")}</Button>
                    </DialogActions>
                </form>
            </Dialog>



            <Dialog
                open={openHistory}
                onClose={handleCloseHistory}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    {t("applicationDetail.modal.archive")}
                </DialogTitle>
                <DialogContent>
                    <DocumentalHistory functionality={"APPL"} id={applicationData.id} documentsTitles={documentsList}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseHistory}>{t("applicationDetail.modal.cancel")}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Documentation;